/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Tomorrow_Colour_CodeInputs */

const en_field_tomorrow_colour_code = /** @type {(inputs: Field_Tomorrow_Colour_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow colour code`)
};

/**
* | output |
* | --- |
* | "Tomorrow colour code" |
*
* @param {Field_Tomorrow_Colour_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_tomorrow_colour_code = /** @type {((inputs?: Field_Tomorrow_Colour_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Tomorrow_Colour_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_tomorrow_colour_code(inputs)
});